import {
  USER_TEST_ACTION,
} from './constants';

export function userTestAction() {
  return {
    type: USER_TEST_ACTION,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USER_TEST_ACTION:
      return {
        ...state,
      };

    default:
      return state;
  }
}
